import { create } from "zustand";

import {
  RecommendationScope,
  RecommendationState,
  RecommendationType,
} from "@type/Recommendation";

type RecommendationsFilter = {
  scopes: RecommendationScope[];
  types: RecommendationType[];
  states: RecommendationState[];
};

type RecommendationsStore = {
  filter: RecommendationsFilter;
  setFilter(filter: Partial<RecommendationsFilter>): void;
  activeTab: string;
  setActiveTab: (activeTab: string) => void;
};

export const useRecommendationsStore = create<RecommendationsStore>((set) => ({
  filter: {
    scopes: [],
    types: [],
    states: [],
  },
  setFilter: (filter): void =>
    set((state) => ({
      filter: {
        ...state.filter,
        ...filter,
      },
    })),
  activeTab: "",
  setActiveTab: (activeTab): void =>
    set(() => ({
      activeTab,
    })),
}));
